import type { Brand, DocumentsDataQuery } from "@src/__generated__/graphql";
import type { InvoiceStore } from "@src/components/modules/invoices/Create/store";
import { MediaModel } from "@src/utils/components/dropzone";
import { computed, makeObservable } from "mobx";
import type { Project } from "../../Detail/models";

type OrdersWithPdf = DocumentsDataQuery["ordersWithPdf"][0];
type OtherDocumentsWithPdf = DocumentsDataQuery["otherDocumentsWithPdf"][0];
type TBrand = Pick<Brand, "id">;
type TProject = Pick<Project, "id">;

export class WithPdfModel {
  invoiceStore: InvoiceStore;
  id: string;
  brands?: TBrand[];
  projects?: TProject[];
  pdfFiles: MediaModel[];

  constructor(
    src: OrdersWithPdf | OtherDocumentsWithPdf,
    invoiceStore: InvoiceStore,
  ) {
    makeObservable(this);
    this.invoiceStore = invoiceStore;
    this.id = src.id;
    if ("brand" in src) {
      this.brands = [src.brand];
    } else {
      this.brands = src.brands?.filter((i) => i) as TBrand[];
    }
    this.projects = src.projects?.filter((i) => i) as TProject[];
    this.pdfFiles = (src.pdfFiles || []).map((i) => new MediaModel(i));
  }

  @computed get projectIds(): string[] {
    return this.invoiceStore.selectedProjects.map((p) => p.id);
  }

  @computed get relatedTo(): "brand" | "project" | undefined {
    // check if has own project and not only projects that brand has
    const hasOwnProjects = this.projects?.some((p) => {
      return this.projectIds.includes(p.id);
    });

    if (this.projects?.length && !hasOwnProjects) return "brand";
    if (this.projects?.length && hasOwnProjects) return "project";
    return undefined;
  }
}
